import { keepPreviousData, useQuery } from '@tanstack/react-query';

import api from 'src/axios';
import { QUERY_KEY_NOVELTIES_BEST_CANDIDATES } from 'src/keys';

export type SimilarityData = {
  sku: string;
  title: string;
  cosine_similarity_score: number;
  candidate_avg_validated_forecast: number;
  is_same_model: boolean;
  is_same_collection: boolean;
  image_url: string | null;
  purchase_price: number | null;
  purchase_currency: 'USD' | 'EUR' | 'NON DEFINI' | null;
  selling_price: number | null;
};

export type NoveltyProductData = {
  sku: string;
  title: string;
  sales_potential: number | null;
  image_url: string | null;
  purchase_price: number | null;
  purchase_currency: 'USD' | 'EUR' | 'NON DEFINI' | null;
  selling_price: number | null;
  similarities: SimilarityData[];
};

export type NoveltiesReportData = NoveltyProductData[];

export function useNoveltiesBestCandidatesQuery(search: string = '') {
  return useQuery<NoveltiesReportData>({
    queryKey: [QUERY_KEY_NOVELTIES_BEST_CANDIDATES, search],
    placeholderData: keepPreviousData,
    queryFn: async ({ signal }) => {
      const params = new URLSearchParams();
      if (search) {
        params.append('search', search);
      }
      const url = search
        ? `/novelties/best-candidates?${params.toString()}`
        : '/novelties/best-candidates';
      const { data } = await api.get(url, { signal });
      return data;
    },
  });
}
